import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const landingApi = createApi({
  reducerPath: 'teamApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}/landing/`, credentials: "omit" }),
  endpoints: (builder) => ({

    createNewsletterSub: builder.mutation<void, { name: string; surname: string; email: string; }>({
      query: body => ({
        url: `subscribe-newsletter`,
        method: "POST",
        body,
        credentials: 'include'
      }),
    }),

    createContact: builder.mutation<void, { name: string; surname: string; email: string; message: string; }>({
      query: (params) => {
        return {
          url: `contact-us`,
          method: "POST",
          body: params,
          credentials: 'include',
        }
      },
    }),
  }),
});

export const {
  useCreateNewsletterSubMutation,
  useCreateContactMutation,
} = landingApi;